import { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";

import api from "api/api";

//Material UI Components
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { TextareaAutosize } from "@mui/material";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";

//Material UI Icons
import IosShareIcon from "@mui/icons-material/IosShare";
import CloseIcon from "@mui/icons-material/Close";

import ImageMagnifier from "./ImageMagnifier";
import Loader from "./Loader";

// redux
import { useSelector, useDispatch } from "react-redux";
import { showNotification } from "store/features/notificationSlice";

const editDeoProductDetails = [
    ["Study Reference", "study_reference__title"],
    ["Product Name", "product_code"],
    ["Fragrance", "fragrance"],
    ["Fragrance Level", "fragrance_level"],
    ["Ingredients list", "ingredients_list"],
    ["Packaging Body Common Name", "packaging_body_common_name"],
    ["Packaging Body Name", "packaging_body_name"],
    ["Packaging Size Value", "packaging_size_value"],
    ["Packaging Size Unit", "packaging_size_unit"],
    ["Chassis", "chassis"],
    ["Antiperspirant Active", "antiperspirant_active"],
    ["Antiperspirant Active Level", "antiperspirant_active_level"],
    ["Encaps", "encaps"],
    ["Encaps Level", "encaps_level"],
    ["Packaging Actuator Common Name", "packaging_actuator_common_name"],
    ["Packaging Actuator", "packaging_actuator"],
    ["Packaging Valve", "packaging_valve"],
    ["Product Identifier PLM", "product_identifier_plm"],
    ["Product Identifier LIMS", "product_identifier_lims"],
    ["Product Superiority DEO code", "product_superiority_deo_code"],
    ["PC Family Primary Descriptor", "pc_family_primary_descriptor"],
    ["PC Family Secondary Descriptor", "pc_family_secondary_descriptor"],
    ["PC Family Identifier Descriptor", "pc_family_identifier_descriptor"],
    ["Competitor Code", "competitor_code"],
];

const editOralCareProductDetails = [
    ["Study Reference", "study_reference__title"],
    ["Product Name", "product_code"],
    ["Flavour Name", "flavour_name"],
    ["Flavour Dosage Level", "flavour_dosage_level"],
    ["Flavour House Name", "flavour_house_name"],
    ["Sorbitol Level", "sorbitol_level"],
    ["Saccarine Level", "saccarine_level"],
    ["Ingredients List", "ingredients_list"],
    ["Tube Type", "tube_type"],
    ["Carton Type", "carton_type"],
    ["Tube Cap Type", "tube_cap_type"],
    ["Pack Size Tested", "pack_size_tested"],
    ["Type of Chassis", "type_of_chassis"],
    ["Sensory ID", "sensory_id"],
    ["Product Identifier PLM", "product_identifier_plm"],
    ["Product Identifier LIMS", "product_identifier_lims"],
    ["Primary Claim", "primary_claim"],
];

const editSkinCleansingProductDetails = [
    ["Study Reference", "study_reference__title"],
    ["Product Name", "product_code"],
    ["Fragrance", "fragrance"],
    ["Fragrance Level", "fragrance_level"],
    ["Fragrance Technology", "fragrance_technology"],
    ["Ingredients list", "ingredients_list"],
    ["Starch Level", "starch_level"],
    ["% Total AD", "percentage_total_ad"],
    ["% Glycerin", "percentage_glycerin"],
    ["Packaging Size Unit", "packaging_size_unit"],
    ["Chassis", "chassis"],
    ["TFM", "tfm"],
    ["BLEND", "blend"],
    ["12 Hydroxy Stearic Acid", "twelve_hydroxy_stearic_acid"],
    ["Noodle", "noodle"],
    ["Colour", "colour"],
    ["Product Identifier PLM", "product_identifier_plm"],
    ["Product Identifier LIMS", "product_identifier_lims"],
    ["Competitor Code", "competitor_code"],
];

const editFragranceHouseProductDetails = [
    ["Study Reference", "study_reference__title"],
    ["Product Name", "product_code"],
    ["Fragrance", "fragrance"],
    ["Fragrance Level", "fragrance_level"],
    ["Ingredients List", "ingredients_list"],
    ["Packaging Body Common Name", "packaging_body_common_name"],
    ["Packaging Body Name", "packaging_body_name"],
    ["Packaging Size Value", "packaging_size_value"],
    ["Packaging Size Unit", "packaging_size_unit"],
    ["Chassis", "chassis"],
    ["Antiperspirant Active", "antiperspirant_active"],
    ["Antiperspirant Active Level", "antiperspirant_active_level"],
    ["Encaps", "encaps"],
    ["Encaps Level", "encaps_level"],
    ["Packaging Actuator Common Name", "packaging_actuator_common_name"],
    ["Packaging Actuator", "packaging_actuator"],
    ["Packaging Valve", "packaging_valve"],
    ["Product Identifier PLM", "product_identifier_plm"],
    ["Product Identifier LIMS", "product_identifier_lims"],
    ["Product Superiority DEO Code", "product_superiority_deo_code"],
    ["PC Family Primary Descriptor", "pc_family_primary_descriptor"],
    ["PC Family Secondary Descriptor", "pc_family_secondary_descriptor"],
    ["PC Family Identifier Descriptor", "pc_family_identifier_descriptor"],
    ["Competitor Code", "competitor_code"],
    ["% Glycerin", "percentage_glycerin"],
    ["% Total AD", "percentage_total_ad"],
    ["12 Hydroxy Stearic Acid", "hydroxy_stearic_acid_12"],
    ["BLEND", "blend"],
    ["Carton Type", "carton_type"],
    ["Colour", "colour"],
    ["Flavour Dosage Level", "flavour_dosage_level"],
    ["Flavour House Name", "flavour_house_name"],
    ["Flavour Name", "flavour_name"],
    ["Fragrance Dosage Level", "fragrance_dosage_level"],
    ["Fragrance Name", "fragrance_name"],
    ["Fragrance Technology", "fragrance_technology"],
    ["Ingredient List", "ingredient_list"],
    ["Mica/Pearl Level", "mica_pearl_level"],
    ["No. of Products", "no_of_products"],
    ["Noodle", "noodle"],
    ["Pack Size Tested", "pack_size_tested"],
    ["Packaging Type", "packaging_type"],
    ["Primary Claim", "primary_claim"],
    ["Product Color", "product_color"],
    ["Saccarine Level", "saccarine_level"],
    ["Sensory ID", "sensory_id"],
    ["Sorbitol Level", "sorbitol_level"],
    ["Starch Level", "starch_level"],
    ["TFM", "tfm"],
    ["Tube Cap Type", "tube_cap_type"],
    ["Tube Type", "tube_type"],
    ["Type of Chassis", "type_of_chassis"],
    ["Ucode", "ucode"],
    ["Briefing ID", "briefing_id"],
    ["Project Code", "project_code"],
    ["Base Batch LIMS Code", "base_batch_lims_code"],
    ["CTI Masked Code", "cti_masked_code"],
    ["Fragrance ID 1", "fragrance_id_1"],
    ["Fragrance ID 2", "fragrance_id_2"],
];


const deoProductDetails = [
    ["Brand", "brand"],
    ["Product Name", "product_code"],
    ["Format", "format_data"],
    ["Study Reference", "study_reference__title"],
    ["Study Period", "study_period__title"],
    ["Sharepoint Link", "share_point_link"],
    ["Fragrance", "fragrance"],
    ["Fragrance Level", "fragrance_level"],
    ["Ingredients list", "ingredients_list"],
    ["Packaging Body Common Name", "packaging_body_common_name"],
    ["Packaging Body Name", "packaging_body_name"],
    ["Packaging Size", "packaging_size_value"],
    ["Packaging Size Unit", "packaging_size_unit"],
    ["Chassis", "chassis"],
    ["Antiperspirant Active", "antiperspirant_active"],
    ["Antiperspirant Active Level", "antiperspirant_active_level"],
    ["Encaps", "encaps"],
    ["Encaps Level", "encaps_level"],
    ["Packaging Actuator Common Name", "packaging_actuator_common_name"],
    ["Packaging Actuator", "packaging_actuator"],
    ["Packaging Valve", "packaging_valve"],
    ["Product Identifier PLM", "product_identifier_plm"],
    ["Product Identifier LIMS", "product_identifier_lims"],
    ["Product Superiority DEO code", "product_superiority_deo_code"],
    ["PC Family Primary Descriptor", "pc_family_primary_descriptor"],
    ["PC Family Secondary Descriptor", "pc_family_secondary_descriptor"],
    ["PC Family Identifier Descriptor", "pc_family_identifier_descriptor"],
    ["Competitor Code", "competitor_code"],
];

const oralCareProductDetails = [
    ["Product Code", "product_code"],
    ["Brand", "brand"],
    ["Format", "format_data"],
    ["Study Reference", "study_reference__title"],
    ["Study Period", "study_period__title"],
    ["Share Point Link", "share_point_link"],
    ["Flavour Name", "flavour_name"],
    ["Flavour Dosage Level", "flavour_dosage_level"],
    ["Flavour House Name", "flavour_house_name"],
    ["Sorbitol Level", "sorbitol_level"],
    ["Saccarine Level", "saccarine_level"],
    ["Ingredients List", "ingredients_list"],
    ["Tube Type", "tube_type"],
    ["Carton Type", "carton_type"],
    ["Tube Cap Type", "tube_cap_type"],
    ["Pack Size Tested", "pack_size_tested"],
    ["Type of Chassis", "type_of_chassis"],
    ["Sensory ID", "sensory_id"],
    ["Product Identifier PLM", "product_identifier_plm"],
    ["Product Identifier LIMS", "product_identifier_lims"],
    ["Primary Claim", "primary_claim"],
];

const SkinCleansingProductDetails = [
    ["Brand", "brand"],
    ["Product Name", "product_code"],
    ["Format", "format_data"],
    ["Study Reference", "study_reference__title"],
    ["Study Period", "study_period__title"],
    ["Sharepoint Link", "share_point_link"],
    ["Fragrance", "fragrance"],
    ["Fragrance Level", "fragrance_level"],
    ["Fragrance Technology", "fragrance_technology"],
    ["Ingredients list", "ingredients_list"],
    ["Starch Level", "starch_level"],
    ["% Total AD", "percentage_total_ad"],
    ["% Glycerin", "percentage_glycerin"],
    ["Packaging Size Unit", "packaging_size_unit"],
    ["Chassis", "chassis"],
    ["TFM", "tfm"],
    ["BLEND", "blend"],
    ["12 Hydroxy Stearic Acid", "twelve_hydroxy_stearic_acid"],
    ["Noodle", "noodle"],
    ["Colour", "colour"],
    ["Product Identifier PLM", "product_identifier_plm"],
    ["Product Identifier LIMS", "product_identifier_lims"],
    ["Competitor Code", "competitor_code"],
];

const hairCareProductDetails = [
    ["Brand", "brand"],
    ["Product Name", "product_code"],
    ["Format", "format_data"],
    ["Study Reference", "study_reference__title"],
    ["Study Period", "study_period__title"],
    ["Share Point Link", "share_point_link"],
    ["No. of products", "number_of_products"],
    ["Fragrance Name", "fragrance_name"],
    ["Fragrance dosage level", "fragrance_dosage_level"],
    ["Colour", "colour"],
    ["Mica/pearl level", "mica_pearl_level"],
    ["Ingredients list", "ingredients_list"],
    ["Type of Chassis", "type_of_chassis"],
    ["Sensory ID", "sensory_id"],
    ["Product Identifier PLM", "product_identifier_plm"],
    ["Product Identifier LIMS", "product_identifier_lims"],
];

const skinCareProductDetails = [
    ["Brand", "brand"],
    ["Product Name", "product_code"],
    ["Format", "format_data"],
    ["Study Reference", "study_reference__title"],
    ["Study Period", "study_period__title"],
    ["Share Point Link", "share_point_link"],
    ["Product Identifier PLM", "product_identifier_plm"],
    ["Product Identifier LIMS", "product_identifier_lims"],
    ["Ingredient list", "ingredient_list"],
    ["Packaging Type", "packaging_type"],
    ["Product Color", "product_color"],
];

const fragranceHouseProductDetails = [
    ["Product Name", "product_code"],
    ["Fragrance", "fragrance"],
    ["Fragrance Level", "fragrance_level"],
    ["Ingredients List", "ingredients_list"],
    ["Packaging Body Common Name", "packaging_body_common_name"],
    ["Packaging Body Name", "packaging_body_name"],
    ["Packaging Size Value", "packaging_size_value"],
    ["Packaging Size Unit", "packaging_size_unit"],
    ["Chassis", "chassis"],
    ["Antiperspirant Active", "antiperspirant_active"],
    ["Antiperspirant Active Level", "antiperspirant_active_level"],
    ["Encaps", "encaps"],
    ["Encaps Level", "encaps_level"],
    ["Packaging Actuator Common Name", "packaging_actuator_common_name"],
    ["Packaging Actuator", "packaging_actuator"],
    ["Packaging Valve", "packaging_valve"],
    ["Product Identifier PLM", "product_identifier_plm"],
    ["Product Identifier LIMS", "product_identifier_lims"],
    ["Product Superiority DEO Code", "product_superiority_deo_code"],
    ["PC Family Primary Descriptor", "pc_family_primary_descriptor"],
    ["PC Family Secondary Descriptor", "pc_family_secondary_descriptor"],
    ["PC Family Identifier Descriptor", "pc_family_identifier_descriptor"],
    ["Competitor Code", "competitor_code"],
    ["% Glycerin", "percentage_glycerin"],
    ["% Total AD", "percentage_total_ad"],
    ["12 Hydroxy Stearic Acid", "hydroxy_stearic_acid_12"],
    ["BLEND", "blend"],
    ["Carton Type", "carton_type"],
    ["Colour", "colour"],
    ["Flavour Dosage Level", "flavour_dosage_level"],
    ["Flavour House Name", "flavour_house_name"],
    ["Flavour Name", "flavour_name"],
    ["Fragrance Dosage Level", "fragrance_dosage_level"],
    ["Fragrance Name", "fragrance_name"],
    ["Fragrance Technology", "fragrance_technology"],
    ["Ingredient List", "ingredient_list"],
    ["Mica/Pearl Level", "mica_pearl_level"],
    ["No. of Products", "no_of_products"],
    ["Noodle", "noodle"],
    ["Pack Size Tested", "pack_size_tested"],
    ["Packaging Type", "packaging_type"],
    ["Primary Claim", "primary_claim"],
    ["Product Color", "product_color"],
    ["Saccarine Level", "saccarine_level"],
    ["Sensory ID", "sensory_id"],
    ["Sorbitol Level", "sorbitol_level"],
    ["Starch Level", "starch_level"],
    ["TFM", "tfm"],
    ["Tube Cap Type", "tube_cap_type"],
    ["Tube Type", "tube_type"],
    ["Type of Chassis", "type_of_chassis"],
    ["Ucode", "ucode"],
    ["Briefing ID", "briefing_id"],
    ["Project Code", "project_code"],
    ["Base Batch LIMS Code", "base_batch_lims_code"],
    ["CTI Masked Code", "cti_masked_code"],
    ["Fragrance ID 1", "fragrance_id_1"],
    ["Fragrance ID 2", "fragrance_id_2"],
];

  
const otherCategoryTextareaFields = ["ingredients_list", "packaging_body_name", "packaging_valve", "type_of_chassis"];

const ufhTextareaFields = [
    "encaps_level",
    "blend",
    "colour",
    "flavour_name",
    "fragrance_name",
    "fragrance_technology",
    "ingredient_list",
    "mica_pearl_level",
    "noodle",
    "pack_size_tested",
    "packaging_type",
    "primary_claim",
    "product_color",
    "tfm"
];

function ProductInfo({ settings, info, productsSecondaryData = [] }) {
    const dispatch = useDispatch();
    const { productDetailsDialogueOpen, setProductDetailsDialogueOpen, isEdit = false } = settings;
    const { coreDataId, productCode, isCompetitor = false } = info;

    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    // const productsSecondaryDataState = useSelector((state) => state.analysisResultsStore.agreementAnalysisResult);
    const competitorProducts = productsSecondaryData?.filter((ele) => ele.isCompetitorProduct)?.map((ele) => ele.title);

    const isDeodorants = process.env?.REACT_APP_DEODORANTS?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isOralCare = process.env?.REACT_APP_ORAL_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCleansing = process.env?.REACT_APP_SKIN_CLEANSING?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isUnileverFragranceHouse = process.env?.REACT_APP_UNILEVER_FRAGRANCE_HOUSE?.toLowerCase() === productCategoryData?.label?.toLowerCase();

    const textareaFields = isUnileverFragranceHouse
        ? ufhTextareaFields
        : otherCategoryTextareaFields;
        
    const [selectedProductData, setSelectedProductData] = useState({});
    const [selectedProductImage, setSelectedProductImage] = useState(null);
    const [selectedEditProductImage, setSelectedEditProductImage] = useState({});

    //loader variables
    const [isLoading, setIsLoading] = useState(false);
    const [loaderMessage, setLoaderMessage] = useState("Uploading");

    const getProductData = useCallback(async () => {
        if (productDetailsDialogueOpen) {
            setIsLoading(true)
            let url;
            if (isDeodorants) {
                url = process.env.REACT_APP_SERVER_PATH + `/products/?core_data_model=${coreDataId}&product_code=${encodeURIComponent(productCode)}`;
            } else if (isOralCare) {
                url = process.env.REACT_APP_SERVER_PATH + `/oral-care-products/?core_data_model=${coreDataId}&product_code=${encodeURIComponent(productCode)}`;
            } else if (isSkinCleansing) {
                url = process.env.REACT_APP_SERVER_PATH + `/skin-cleansing-products/?core_data_model=${coreDataId}&product_code=${encodeURIComponent(productCode)}`;
            } else if (isHairCare) {
                url = process.env.REACT_APP_SERVER_PATH + `/hair-care-products/?core_data_model=${coreDataId}&product_code=${encodeURIComponent(productCode)}`;
            } else if (isSkinCare) {
                url = process.env.REACT_APP_SERVER_PATH + `/skin-care-products/?core_data_model=${coreDataId}&product_code=${encodeURIComponent(productCode)}`;
            } else if (isUnileverFragranceHouse) {
                url = process.env.REACT_APP_SERVER_PATH + `/unilever-fragrance-house-products/?core_data_model=${coreDataId}&product_code=${encodeURIComponent(productCode)}`;
            }
            try {
                await api
                    .get(url)
                    .then(async (res) => {
                        if (res.data.length !== 0) {
                            setSelectedProductData(res.data[0]);
                        }
                    })
                    .catch(async (error) => {
                        handleError("error", error);
                    });
            } catch (error) {
                handleError("error", error);
            }
            const imageUrl = process.env.REACT_APP_SERVER_PATH + `/product-images/?core_data_model=${coreDataId}&title=${encodeURIComponent(productCode)}`;
            // const imageBaseUrl = process.env.REACT_APP_MEDIA_PATH;
            try {
                await api.get(imageUrl)
                    .then(async (res) => {
                        setSelectedProductImage(res?.data?.[0]?.product_images || null);
                        // if (process.env.REACT_APP_LOCAL_ENV === "True") {
                        //     setSelectedProductImage(res?.data?.[0]?.product_images || null);
                        // } else if (res.data.length !== 0 && res.data[0].product_images.split("filestorage").length !== 0) {
                        //     const imagePath = imageBaseUrl + res.data[0].product_images.split(".unilever.com")[1];
                        //     setSelectedProductImage(imagePath);
                        // } else {
                        //     setSelectedProductImage(null);
                        // }
                    })
                    .catch(async (error) => {
                        handleError("error", error);
                    });
            } catch (error) {
                handleError("error", error);
            } finally {
                setIsLoading(false)
            }
        }
    }, [isDeodorants, isOralCare, isSkinCleansing, isHairCare, isSkinCare, isUnileverFragranceHouse, coreDataId, productCode, productDetailsDialogueOpen]);

    useEffect(() => {
        getProductData();
    }, [getProductData]);

    const handleProductDetailsDialogue = () => {
        setProductDetailsDialogueOpen(false);
        setSelectedProductData({});
        setSelectedProductImage(null);
    };
    const handleError = (type, error) => {
        dispatch(showNotification({ severity: type, data: error }));
    };

    const returnDeoData = () => {
        const html = deoProductDetails.map((row, i) => {
            const label = row[0];
            const key = row[1];

            if (label === "Competitor Code" && !competitorProducts.includes(selectedProductData["product_code"])) {
                return null;
            }

            let value = selectedProductData[key] ? selectedProductData[key] : "";

            if (label === "Study Period" && value) {
                // Convert from 'YYYY/MM' to 'MM/YYYY'
                const [year, month] = value.split("/");
                value = `${month}/${year}`;
            }

            if (label === "Packaging Size") {
                const unit = selectedProductData["packaging_size_unit"] || "";
                value = `${value} ${unit}`;
            } else if (label === "Packaging Size Unit") {
                return null;
            }

            // Check if the value is in exponential notation
            const isExponential = /\d+\.?\d*e[+-]?\d+/i.test(value);
            if (isExponential) {
                value = parseFloat(value).toFixed(5);
            }

            // Determine if the field should use a textarea instead of an input
            const isTextareaField = textareaFields.includes(key);
            return (
                <div
                    key={i + 1}
                    className="product-details-input-labels-container"
                >
                    <label
                        htmlFor={key}
                        className="product-details-label"
                    >
                        {label}:
                    </label>
                    {key === "share_point_link" ? (
                        <a
                            href={selectedProductData["share_point_link"]}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "inline-block",
                            }}
                        >
                            {selectedProductData["share_point_link"]}
                        </a>
                    ) : isTextareaField ? (
                        <p>{value}</p>
                    ) : (
                        <input
                            readOnly="readonly"
                            type="text"
                            name="sharepointLink"
                            value={value}
                        />
                    )}
                </div>
            );
        });
        return html;
    };
    const returnOralCareData = () => {
        const html = oralCareProductDetails.map((row, i) => {
            const label = row[0];
            const key = row[1];

            let value = selectedProductData[key] ? selectedProductData[key] : "";

            // Check if the value is in exponential notation
            const isExponential = /\d+\.?\d*e[+-]?\d+/i.test(value);
            if (isExponential) {
                value = parseFloat(value).toFixed(5);
            }

            const isTextareaField = textareaFields.includes(key);

            return (
                <div
                    key={i}
                    className="product-details-input-labels-container"
                >
                    <label
                        htmlFor={key}
                        className="product-details-label"
                    >
                        {label}:
                    </label>
                    {isTextareaField ? (
                        <p>{value}</p>
                    ) : (
                        <input
                            readOnly="readonly"
                            type="text"
                            value={value}
                        />
                    )}
                </div>
            );
        });
        return html;
    };

    const returnSkinCleansingData = () => {
        const html = SkinCleansingProductDetails.map((row, i) => {
            const label = row[0];
            const key = row[1];

            let value = selectedProductData[key] ? selectedProductData[key] : "";

            // Check if the value is in exponential notation
            const isExponential = /\d+\.?\d*e[+-]?\d+/i.test(value);
            if (isExponential) {
                value = parseFloat(value).toFixed(5);
            }

            const isTextareaField = textareaFields.includes(key);
            const uniqueKey = `field_${i}`;

            return (
                <div
                    key={uniqueKey}
                    className="product-details-input-labels-container"
                >
                    <label
                        htmlFor={key}
                        className="product-details-label"
                    >
                        {label}:
                    </label>
                    {isTextareaField ? (
                        <p>{value}</p>
                    ) : (
                        <input
                            readOnly="readonly"
                            type="text"
                            value={value}
                        />
                    )}
                </div>
            );
        });
        return html;
    };

    const returnHairCareData = () => {
        const html = hairCareProductDetails.map((row, i) => {
            const label = row[0];
            const key = row[1];

            let value = selectedProductData[key] ? selectedProductData[key] : "";

            // Check if the value is in exponential notation
            const isExponential = /\d+\.?\d*e[+-]?\d+/i.test(value);
            if (isExponential) {
                value = parseFloat(value).toFixed(5);
            }

            const isTextareaField = textareaFields.includes(key);

            return (
                <div
                    key={i}
                    className="product-details-input-labels-container"
                >
                    <label
                        htmlFor={key}
                        className="product-details-label"
                    >
                        {label}:
                    </label>
                    {key === "share_point_link" ? (
                        <a
                            href={selectedProductData["share_point_link"]}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "inline-block",
                            }}
                        >
                            {selectedProductData["share_point_link"]}
                        </a>
                    ) : isTextareaField ? (
                        <p>{value}</p>
                    ) : (
                        <input
                            readOnly="readonly"
                            type="text"
                            value={value}
                        />
                    )}
                </div>
            );
        });
        return html;
    };

    const returnSkinCareData = () => {
        const html = skinCareProductDetails.map((row, i) => {
            const label = row[0];
            const key = row[1];

            let value = selectedProductData[key] ? selectedProductData[key] : "";

            // Check if the value is in exponential notation
            const isExponential = /\d+\.?\d*e[+-]?\d+/i.test(value);
            if (isExponential) {
                value = parseFloat(value).toFixed(5);
            }

            const isTextareaField = textareaFields.includes(key);

            return (
                <div
                    key={i}
                    className="product-details-input-labels-container"
                >
                    <label
                        htmlFor={key}
                        className="product-details-label"
                    >
                        {label}:
                    </label>
                    {key === "share_point_link" ? (
                        <a
                            href={selectedProductData["share_point_link"]}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "inline-block",
                            }}
                        >
                            {selectedProductData["share_point_link"]}
                        </a>
                    ) : isTextareaField ? (
                        <p>{value}</p>
                    ) : (
                        <input
                            readOnly="readonly"
                            type="text"
                            value={value}
                        />
                    )}
                </div>
            );
        });
        return html;
    };

    const returnUnileverFragranceHouseData = () => {
        const html = fragranceHouseProductDetails.map((row, i) => {
            const label = row[0];
            const key = row[1];

            let value = selectedProductData[key] ? selectedProductData[key] : "";

            // Check if the value is in exponential notation
            const isExponential = /\d+\.?\d*e[+-]?\d+/i.test(value);
            if (isExponential) {
                value = parseFloat(value).toFixed(5);
            }

            const isTextareaField = textareaFields.includes(key);

            return (
                <div
                    key={i}
                    className="product-details-input-labels-container"
                >
                    <label
                        htmlFor={key}
                        className="product-details-label"
                    >
                        {label}:
                    </label>
                    {key === "share_point_link" ? (
                        <a
                            href={selectedProductData["share_point_link"]}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "inline-block",
                            }}
                        >
                            {selectedProductData["share_point_link"]}
                        </a>
                    ) : isTextareaField ? (
                        <p>{value}</p>
                    ) : (
                        <input
                            readOnly="readonly"
                            type="text"
                            value={value}
                        />
                    )}
                </div>
            );
        });
        return html;
    };

    const handleInputChange = (value, key) => {
        setSelectedProductData((prev) => {
            return {
                ...prev,
                [key]: value,
            };
        });
    };

    const returnEditData = () => {
        let proDetails;
        if (isDeodorants) {
            proDetails = editDeoProductDetails;
        } else if (isOralCare) {
            proDetails = editOralCareProductDetails;
        } else if (isSkinCleansing) {
            proDetails = editSkinCleansingProductDetails;
        } else if (isHairCare) {
            proDetails = hairCareProductDetails;
        } else if (isSkinCare) {
            proDetails = skinCareProductDetails;
        } else if (isUnileverFragranceHouse) {
            proDetails = editFragranceHouseProductDetails;
        }

        const html = proDetails.map((row, i) => {
            const label = row[0];
            const key = row[1];
            let value = selectedProductData[key] ? selectedProductData[key] : "";
            const isTextareaField = textareaFields.includes(key);
            const isReadOnly = label === "Study Reference" || label === "Product Name";

            if (label === "Brand" || label === "Format" || label === "Study Period" || label === "Sharepoint Link") {
                return null;
            }

            if (label === "Competitor Code" && !isCompetitor) {
                return null;
            }

            const uniquekey = `${label}-${i}`;
            return (
                <div
                    key={uniquekey}
                    className="product-details-input-labels-container"
                >
                    <label
                        htmlFor={key}
                        className="product-details-label"
                    >
                        {label}:
                    </label>
                    {isTextareaField ? (
                        <TextareaAutosize
                            placeholder={label}
                            value={value}
                            onChange={(e) => handleInputChange(e.target.value, key)}
                            minRows={1}
                            style={{
                                color: "#424242d4",
                                width: "70%",
                                fontSize: "13px",
                                padding: "1px 10px",
                                borderRadius: "3px",
                                border: "1px solid #49505772",
                            }}
                        />
                    ) : (
                        <input
                            readOnly={isReadOnly && "readonly"}
                            type="text"
                            placeholder={label}
                            value={value}
                            onChange={(e) => handleInputChange(e.target.value, key)}
                        />
                    )}
                </div>
            );
        });

        return html;
    };

    const handleUpdateMetaData = async () => {
        try {
            setLoaderMessage("Updating");
            setIsLoading(true);
            let url;
            if (isDeodorants) {
                url = process.env.REACT_APP_SERVER_PATH + `/products/${selectedProductData.id}/`;
            } else if (isOralCare) {
                url = process.env.REACT_APP_SERVER_PATH + `/oral-care-products/${selectedProductData.id}/`;
            } else if (isSkinCleansing) {
                url = process.env.REACT_APP_SERVER_PATH + `/skin-cleansing-products/${selectedProductData.id}/`;
            } else if (isHairCare) {
                url = process.env.REACT_APP_SERVER_PATH + `/hair-care-products/${selectedProductData.id}/`;
            } else if (isSkinCare) {
                url = process.env.REACT_APP_SERVER_PATH + `/skin-care-products/${selectedProductData.id}/`;
            } else if (isUnileverFragranceHouse) {
                url = process.env.REACT_APP_SERVER_PATH + `/unilever-fragrance-house-products/${selectedProductData.id}/`;
            }
            await api
                .patch(url, selectedProductData)
                .then(async () => {
                    setIsLoading(false);
                    handleProductDetailsDialogue();
                })
                .catch((error) => {
                    handleError("error", error);
                });
        } catch (error) {
            setIsLoading(false);
            handleError("error", error);
        }
    };

    const handleFileChange = (event) => {
        if (event.target.files.length === 0) {
            return;
        }

        if (event.target.files[0]?.size <= 1048576) {
            const uploadedImage = event.target.files[0];
            const uploadedImageTitle = Date.now() + event.target.files[0].name.replace(/\s/g, "");

            const reader = new FileReader();
            reader.onload = () => {
                setSelectedEditProductImage((prev) => {
                    return {
                        ...prev,
                        productCode: selectedProductData?.product_code,
                        imagePath: reader.result,
                        imageData: uploadedImage,
                        imageTitle: uploadedImageTitle,
                    };
                });
            };
            reader.onerror = () => {
                handleError("error", "Failed to read image");
            };

            reader.readAsDataURL(uploadedImage);
        } else {
            handleError("error", "Max size limit 1MB");
        }
    };

    const submitProductImage = async () => {
        if (Object.keys(selectedEditProductImage).length !== 0) {
            try {
                if (selectedEditProductImage?.id === undefined) {
                    setLoaderMessage("Uploading");
                    setIsLoading(true);
                    const url = process.env.REACT_APP_SERVER_PATH + `/product-images/`;
                    const formData = new FormData();

                    formData.append("product_images", selectedEditProductImage?.imageData);
                    formData.append("title", selectedEditProductImage?.productCode);
                    formData.append("description", selectedEditProductImage?.imageTitle);
                    formData.append("core_data_model", coreDataId);

                    const config = {
                        headers: {
                            "content-type": "multipart/form-data",
                        },
                    };
                    await api
                        .post(url, formData, config)
                        .then(async () => {
                            setSelectedEditProductImage({});
                            setIsLoading(false);
                            handleProductDetailsDialogue();
                        })
                        .catch((error) => {
                            setIsLoading(false);
                            handleError("error", error);
                        });
                } else {
                    setLoaderMessage("Uploading");
                    setIsLoading(true);
                    const formData = new FormData();

                    formData.append("product_images", selectedProductImage.imageData);

                    const config = {
                        headers: {
                            "content-type": "multipart/form-data",
                        },
                    };
                    if (typeof selectedProductImage.imageData === "object") {
                        const url = process.env.REACT_APP_SERVER_PATH + `/product-images/${selectedProductImage.id}/`;
                        await api
                            .patch(url, formData, config)
                            .then(async () => {
                                setSelectedEditProductImage({});
                                setIsLoading(false);
                                handleProductDetailsDialogue();
                            })
                            .catch((error) => {
                                setIsLoading(false);
                                handleError("error", error);
                            });
                    }
                }
            } catch (error) {
                setIsLoading(false);
                handleError("error", error);
            }
        }
        setIsLoading(false);
    };

    const handleSubmit = () => {
        submitProductImage();
        handleUpdateMetaData();
    };

    return (
        <div>
            {isLoading && <Loader message={loaderMessage} />}
            <Dialog
                open={productDetailsDialogueOpen}
                // onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="md"
                fullWidth={true}
            >
                <DialogTitle
                    style={{
                        backgroundColor: "rgb(51, 94, 234,0.1)",
                        color: "rgb(51, 94, 234)",
                        fontSize: 15,
                        textAlign: "center",
                        padding: "10px 12px",
                    }}
                >
                    Product Details
                    <IconButton
                        aria-label="close"
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 5,
                            color: "rgb(51, 94, 234) !important",
                        }}
                        size="small"
                        onClick={handleProductDetailsDialogue}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <div className="row">
                        <div
                            className="col-5 p-3"
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                flexDirection: "column",
                            }}
                        >
                            <div
                                className="product-image-container"
                                style={{
                                    margin: "auto",
                                }}
                            >
                                <ImageMagnifier src={isEdit ? selectedEditProductImage?.imagePath || selectedProductImage : selectedProductImage} />
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                {isEdit ? (
                                    <Button
                                        className="custom-btn custom-btn-outlined color-blue"
                                        size="small"
                                        variant="outlined"
                                        component="label"
                                        style={{
                                            height: "31px",
                                            padding: 0,
                                        }}
                                    >
                                        <input
                                            hidden
                                            accept=".jpg,.png"
                                            type="file"
                                            onChange={(event) => handleFileChange(event)}
                                        />
                                        <span>Upload Product Image</span>
                                    </Button>
                                ) : (
                                    <Button
                                        className="custom-btn custom-btn-outlined color-blue"
                                        size="small"
                                        variant="outlined"
                                        style={{
                                            height: "31px",
                                            padding: 0,
                                        }}
                                        endIcon={<IosShareIcon />}
                                        onClick={() => {
                                            let downloadUrl = null;
                                            if (isDeodorants) {
                                                downloadUrl = process.env.REACT_APP_SERVER_PATH + `/products/export-product-info/?product_code=${encodeURIComponent(selectedProductData.product_code)}&core_data_ids=${encodeURIComponent(selectedProductData.core_data_model)}`;
                                            } else if (isOralCare) {
                                                downloadUrl = `${process.env.REACT_APP_SERVER_PATH}/oral-care-products/export-oral-care-product-info/?product_code=${encodeURIComponent(selectedProductData.product_code)}&core_data_ids=${encodeURIComponent(selectedProductData.core_data_model)}`;
                                            } else if (isSkinCleansing) {
                                                downloadUrl = `${process.env.REACT_APP_SERVER_PATH}/skin-cleansing-products/export-skin-cleansing-product-info/?product_code=${encodeURIComponent(selectedProductData.product_code)}&core_data_ids=${encodeURIComponent(selectedProductData.core_data_model)}`;
                                            } else if (isHairCare) {
                                                downloadUrl = `${process.env.REACT_APP_SERVER_PATH}/hair-care-products/export-hair-care-product-info/?product_code=${encodeURIComponent(selectedProductData.product_code)}&core_data_ids=${encodeURIComponent(selectedProductData.core_data_model)}`;
                                            } else if (isSkinCare) {
                                                downloadUrl = `${process.env.REACT_APP_SERVER_PATH}/skin-care-products/export-skin-care-product-info/?product_code=${encodeURIComponent(selectedProductData.product_code)}&core_data_ids=${encodeURIComponent(selectedProductData.core_data_model)}`;
                                            } else if (isUnileverFragranceHouse) {
                                                downloadUrl = `${process.env.REACT_APP_SERVER_PATH}/unilever-fragrance-house-products/export-skin-care-product-info/?product_code=${encodeURIComponent(selectedProductData.product_code)}&core_data_ids=${encodeURIComponent(selectedProductData.core_data_model)}`;
                                            }
                                            window.open(downloadUrl);
                                        }}
                                    >
                                        Export Product Information
                                    </Button>
                                )}
                            </div>
                        </div>
                        <div className="col-7 p-3">
                            <div
                                style={{
                                    height: 400,
                                    overflow: "auto",
                                }}
                            >
                                {isDeodorants && !isEdit && returnDeoData()}
                                {isOralCare && !isEdit && returnOralCareData()}
                                {isSkinCleansing && !isEdit && returnSkinCleansingData()}
                                {isHairCare && !isEdit && returnHairCareData()}
                                {isSkinCare && !isEdit && returnSkinCareData()}
                                {isUnileverFragranceHouse && !isEdit && returnUnileverFragranceHouseData()}
                                {isEdit && returnEditData()}
                            </div>
                            {isEdit && (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        marginTop: "15px",
                                    }}
                                >
                                    <Button
                                        className="custom-btn custom-btn-outlined color-blue"
                                        size="small"
                                        variant="outlined"
                                        style={{
                                            height: "31px",
                                            padding: 0,
                                        }}
                                        onClick={handleSubmit}
                                    // disabled={true}
                                    >
                                        Update Product Metadata
                                    </Button>
                                </div>
                            )}
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
}

ProductInfo.propTypes = {
    settings: PropTypes.object,
    info: PropTypes.object,
    productsSecondaryData: PropTypes.array,
};
export default ProductInfo;
